import React from 'react';
import PropTypes from 'prop-types';
import {
  Cushion,
  Grid,
  Hide,
  Rectangle,
  Space,
  Shimmer,
  ShimmerTypography,
} from '@pitchero/react-ui';
import ProfilePlaceholder from '../../squad/profile-placeholder';

const StatsLoadingState = ({ placeholdersColumns }) => {
  const renderProfilePlaceholders = () => {
    const placeholders = [];

    for (let i = 1; i <= placeholdersColumns; i += 1) {
      const hideProps = {};
      if (i > 1) {
        hideProps.maxWidth = 'palm';
      }

      placeholders.push(
        <Hide {...hideProps} key={i}>
          <Rectangle>
            <Space all="medium">
              <ShimmerTypography width={100} />
            </Space>
            <Cushion all="small" component="div">
              <ProfilePlaceholder />
            </Cushion>
            <Cushion all="small" component="div">
              <ProfilePlaceholder />
            </Cushion>
            <Cushion all="small" component="div">
              <ProfilePlaceholder />
            </Cushion>
          </Rectangle>
        </Hide>,
      );
    }

    return placeholders;
  };

  return (
    <Space bottom="xxlarge" component="div">
      <Space
        bottom="medium"
        responsive={[{ minWidth: 'palm', props: { bottom: 'large' } }]}
        component="div"
      >
        <Shimmer preset="title" height="44px" radius="22px" />
      </Space>
      <Grid
        columns="1fr"
        columnGap="xlarge"
        rowGap="small"
        responsive={[{ minWidth: 'palm', props: { columns: '1fr 1fr' } }]}
      >
        <Shimmer preset="title" height="175px" />
        <Shimmer preset="title" height="175px" />
      </Grid>
      <Space
        horizontal="small"
        vertical="medium"
        responsive={[{ minWidth: 'palm', props: { horizontal: 'large', vertical: 'large' } }]}
        component="div"
      >
        <Grid
          columns="1fr"
          columnGap="xlarge"
          rowGap="small"
          responsive={[
            {
              minWidth: 'palm',
              props: { columns: '1fr 1fr', rowGap: 'medium', columnGap: 'large' },
            },
            {
              minWidth: 'lap',
              props: { columns: '1fr 1fr 1fr', rowGap: 'medium', columnGap: 'large' },
            },
          ]}
        >
          {renderProfilePlaceholders()}
        </Grid>
      </Space>
    </Space>
  );
};

StatsLoadingState.defaultProps = {
  placeholdersColumns: 3,
};

StatsLoadingState.propTypes = {
  placeholdersColumns: PropTypes.number,
};

export default StatsLoadingState;
